"use strict";
const config = require('../../../../../config/locales_json/packs/private/users/my_postulations.json');
const language = $('body').data("language");
const origin = $('#kt_datatable_postulations').data("p-origin");
// Class definition

var MyPostulationsDatatable = function() {
  // Private functions
  var _init = function() {
      var datatable = $('#kt_datatable_postulations').KTDatatable({
          // datasource definition
          data: {
            type: 'remote',
            source: {
              read: {
                method: 'GET',
                url: '/postulation/my_postulations.json',
                map: function(data) {
                  //console.log(data)
                  //$("#kt_subheader_total").html(data.length + " Total")

                  return data
                }
              },
            },
            pageSize: 10, // display 20 records per page
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
          },

          // layout definition
          layout: {
              scroll: false, // enable/disable datatable scroll both horizontal and vertical when needed.
              footer: false, // display/hide footer
          },

          // column sorting
          sortable: true,

          pagination: true,

          translate: {
            records: {
              processing: getTranslationValue(config, [language, "MyPostulationsDatatable", "translate", "records-processing"],'Cargando...'),
              noRecords: getTranslationValue(config, [language, "MyPostulationsDatatable", "translate", "records-noRecords"],'No has postulado a ninguna oferta aún')
            },
            toolbar: {
              pagination: {
                items: {
                  default: {
                    first: getTranslationValue(config, [language, "MyPostulationsDatatable", "toolbar", "default-first"], 'Primero'),
                    prev: getTranslationValue(config, [language, "MyPostulationsDatatable", "toolbar", "default-prev"], 'Anterior'),
                    next: getTranslationValue(config, [language, "MyPostulationsDatatable", "toolbar", "default-next"], 'Siguiente'),
                    last: getTranslationValue(config, [language, "MyPostulationsDatatable", "toolbar", "default-last"], 'Último'),
                    more: getTranslationValue(config, [language, "MyPostulationsDatatable", "toolbar", "default-more"], 'Más páginas'),
                    input: getTranslationValue(config, [language, "MyPostulationsDatatable", "toolbar", "default-input"], 'Página number'),
                    select: getTranslationValue(config, [language, "MyPostulationsDatatable", "toolbar", "default-select"], 'Selecciona el tamaño de la página')
                  },
                  info: getTranslationValue(config, [language, "MyPostulationsDatatable", "toolbar", "info"], 'Mostrando {{start}} - {{end}} de {{total}} postulaciones')
                }
              }
            }
          },

          // columns definition
          columns: [{
              field: 'title',
              title: getTranslationValue(config, [language, "MyPostulationsDatatable", "columns", "title_field_title"],'Oferta'),
              width: 300,
              template: function(data) {
                var name='';
                var logo='';

                  if (data.is_confidential === true ){
                    name=data.anonymous_name;
                    if (data.anonymous_logo === null){
                      logo='';
                    }else{
                      logo='<img class="" src="' + data.anonymous_logo + '" alt="' + data.name + '"/>';
                    }
                  }else{
                    name=data.client_name;

                    if (origin === 1){
                      logo='';
                    }else{
                      logo='<img class="" src="' + data.logo + '" alt="' + data.name + '"/>';
                    }
                  }
                  var output = '<div class="d-flex align-items-center">\
                    <div class="symbol symbol-sm cont-logo-client">'+ logo +'</div>\
                    <div class="ml-3">\
                      <div class="text-dark-75 font-weight-bolder font-size-lg mb-0">' + data.title + '</div>\
                      <a href="#" class="text-muted font-weight-bold text-hover-primary">' + name + '</a>\
                    </div>\
                  </div>';

                  return output;
              },
          }, {
              field: 'postulation_date',
              title: getTranslationValue(config, [language, "MyPostulationsDatatable", "columns", "postulation_date_title"],'Fecha de Postulación'),
              sortable: 'desc',
              type: 'date',
              width: 120,
              format: 'DD/MM/YYYY',
              template: function(row) {
                var parsedDate = moment(row.postulation_date).format('DD/MM/YYYY');
                var output = '<div class="font-weight-bolder mb-0">' + parsedDate + '</div>';

                return output;
            },
          }, {
              field: 'Status',
              title: getTranslationValue(config, [language, "MyPostulationsDatatable", "columns", "Status_title"],'Estado'),
              width: 100,
              // callback function support for column rendering
              template: function(row) {
                return '<span class="label label-lg font-weight-bold label-inline">'+ row.funnel_state +'</span>';
              },
          }, {
              field: 'Actions',
              title: getTranslationValue(config, [language, "MyPostulationsDatatable", "columns", "Action_title"],'Acciones'),
              sortable: false,
              width: 130,
              overflow: 'visible',
              autoHide: false,
              template: function(row) {
                const deletePostulationText = getTranslationValue(config, [language, "MyPostulationsDatatable", "columns", "Action_output_title"],'Eliminar Postulación')
                const answerQuestionsText = getTranslationValue(config, [language, "MyPostulationsDatatable", "columns", "Action_output_title_question"],'Completar Postulación')

                const deleteBtn = '<button type="button" class="icon delete-button tp" data-toggle="tooltip" data-theme="dark" title="'+ deletePostulationText +'" data-id="'+ row.id +'" data-toggle="modal" data-target="#delete_postulation_modal"><i class="fas fa-trash-alt"></i></button>';

                const questionBtn = row['is_pending'] ? '<a href="'+row['questions_path']+'" class="icon tp" data-toggle="tooltip" data-theme="dark" title="'+ answerQuestionsText +'"><i class="fas fa-question-circle"></i></a>' : '';
                
                var output = '<div class="d-flex align-items-center container-actions-table">'+ questionBtn + deleteBtn +'</div>'

                return output;
              },
          }]
      });
  };

  return {
    // public functions
    init: function() {
        _init();
    },
  };
}();

jQuery(document).ready(function() {
  if($("#kt_datatable_postulations").length > 0){
    MyPostulationsDatatable.init();
  }

  /*************
     * ELIMINAR POSTULACINOES
     *
     * - Logica de activacion de modal,
     * - Asignacion de informacion a hidden field del modal
     * - Validacion y ejecución del formulario
     */
    // Al hacer click en eliminar una postulación
    $("#kt_datatable_postulations").on("click", ".delete-button", function(e){
      $('#delete_postulation_modal').modal('toggle')
      // Obtiene el id de la postulación
      var postulationID = $(this).attr("data-id")
      // Asigna el id de la postulación en el campo hidden del modal
      $("#delete_postulation_modal #hidden_modal_id").val(postulationID)
      // Se asigna la url correspondiente
      var url = '/postulation/unpostuled';
      $("#form_modal_delete_postulation").attr("action", url)
  })

  // Al cerrar el modal limpia la url y el hidden
  $("#delete_postulation_modal .close").on("click", function(e){
      cleanPostulationModalFields()
  })

  // Al hacer click en confirmar eliminacion de universidad
  $("#delete_postulation_modal #cancel_modal_delete_postulation_form").on("click", function(e){
      cleanPostulationModalFields()
  })

  // Al hacer click en enviar universidad
  $("#delete_postulation_modal #send_modal_delete_postulation_form").on("click", function(e){
      // Valida que el campo hidden tenga información
      var postulationID = $("#delete_postulation_modal #hidden_modal_id").val()
      // Si tiene informacion ejecuta el formulario
      if(postulationID.length > 0) {
          // Se desabilitan las acciones
          // Cambia el texto del boton a Eliminando
          const disabledText = getTranslationValue(config, [language, "on_click_send_modal_delete", "disabled_text"],"Eliminando...")
          $(this).addClass("disabled").text(disabledText)

          $("#delete_postulation_modal #cancel_modal_delete_postulation_form").addClass("disabled")
          $("#delete_postulation_modal #close_delete_postulation_modal").addClass("disabled")
          $("#form_modal_delete_postulation").submit()
      } else {
          // Si no se puede eliminar
          const errorText = getTranslationValue(config, [language, "on_click_send_modal_delete", "error_text"],"Hubo un problema y no se pudo eliminar la postulación. Por favor intente más tarde.")
          $(".modal-body").find(".error-modal").remove()
          $(".modal-body").prepend('<div class="error-modal"><i class="fas fa-times-circle"></i><p>'+errorText+'</p></div>')
      }
  })

  // Limpia el campo hidden y la url del form
  function cleanPostulationModalFields(){
      // Limpia si hay errores
      $(".modal-body").find(".error-modal").remove()
      // Limpia el campo hidden
      $("#delete_postulation_modal #hidden_modal_id").val(null)
      // Se limpia la url correspondiente
      var url = '';
      $("#form_modal_delete_postulation").attr("action", url)
  }
  /*************
   * FIN ELIMINAR UNIVERSIDAD
   */
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;

	let currentTranslation;
	let firstIteration = true;

	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {

      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
